import router from "@/router";
import axios from "axios";
import Vue from "vue";

// 创建axios实例
const request = axios.create({
  baseURL: '/api', // 使用相对路径，通过vue.config.js中的代理转发
  timeout: 10000,
  withCredentials: true // 允许跨域请求携带凭证
})

// 请求拦截器，为非登录请求添加token
request.interceptors.request.use(
  config => {
    const {isMock} = config.data || {};
    if (isMock) {
      config.baseURL = '/mock';
    }
    console.log('API请求路径:', config.url);
    // 排除登录相关接口，不需要token
    // 由于axios配置了baseURL为'/api'，且后端Controller类也有/api前缀，所以这里只需要检查不带/api前缀的路径
    const url = config.url;
    const isLoginRequest = url === '/login' ||
                          url === '/login/phone' ||
                          url === '/sms/send-code';
    // 确保登录请求不会被添加token
    if (isLoginRequest) {
      console.log('登录相关请求，不添加token');
      // 确保Authorization头不会被设置
      delete config.headers.Authorization;
    } else {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config
  },
  error => {
    console.error('请求拦截器错误:', error);
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    console.log('API响应状态:', response.status);
    return response
  },
  error => {
    console.error('API响应错误:', error);
    // 检查是否是401错误（token过期或无效）
    if (error.response && error.response.status === 401) {
      // 简化检测是否为登录请求，使用includes方法更灵活
      const isLoginRequest = error.config &&
                           (error.config.url &&
                            (error.config.url.includes('/login') ||
                             error.config.url.includes('/sms/send-code')));
      // 只对非登录请求进行token过期处理
      if (!isLoginRequest) {
        // 添加window.tokenExpiredHandled标志防止多个并发请求同时触发token过期处理
        if (!window.tokenExpiredHandled) {
          window.tokenExpiredHandled = true;
          console.log('Token验证失败，执行过期处理...');

          // Clear user data from storage
          localStorage.removeItem('token');
          sessionStorage.removeItem('token');

          try {
            // 获取当前路径，使用更可靠的方式
            const currentPath = window.location.pathname || router.currentRoute.path;
            // 避免重复导航到登录页
            if (!currentPath.includes('/login')) {
              console.log('当前不在登录页，执行跳转...');
              const current = router.currentRoute;
              const query = new URLSearchParams(current.query)

              const ua = navigator.userAgent.toLowerCase()
              const isInDingTalk = ua.indexOf('dingtalk') > -1 || ua.indexOf('dingtalk') > -1;

              if (isInDingTalk) {
                localStorage.setItem('redirectAfterLogin', currentPath + (query ? `?${query}` : ''));
                router.replace({
                  name: 'DingLogin',
                  query: current.query
                });
                return
              }

              // 使用replace方法代替push，避免浏览器历史记录问题
              router.replace('/login');
              // 确保消息提示显示
              Vue.prototype.$message.error('登录已过期，请重新登录');
            }
          } catch (navigationError) {
            console.error('导航失败，尝试直接页面跳转:', navigationError);
            // 如果路由跳转失败，尝试直接修改URL
            window.location.href = '/login';
          }

          // 重置标志位，允许下次处理
          setTimeout(() => {
            window.tokenExpiredHandled = false;
          }, 1000);
        } else {
          console.log('已有请求正在处理token过期，跳过当前请求的处理');
        }
      }
    }
    // 对于其他错误，继续传递给调用方处理
    return Promise.reject(error)
  }
)


export default {
  request
}